import { ButtonProps } from '../../atoms/Button';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';


type EmptyStateBannerInternalProps = {
  icon?: IconProps;
  title?: TextProps;
  message?: TextProps;
  button?: ButtonProps;
};

type EmptyStateBannerPropsValues = {
  '': EmptyStateBannerInternalProps;
};

const propValues: EmptyStateBannerPropsValues = {
  '': {
    icon: {
      asset: 'TicketBig',
      style: 'DigitalGrey30',
    },
    title: {
      type: 'Subheading',
      size: 'Small',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Center',
    },
    message: {
      type: 'Body',
      size: 'Large',
      style: 'Regular',
      colour: 'SubduedDark',
      align: 'Center',
    },
    button: {
      type: 'Text',
      style: 'Outline',
      size: 'Medium',
    },
  },
};

const getProps = (type: string): EmptyStateBannerInternalProps => {
  const values: EmptyStateBannerInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
